export default __webpack_public_path__ + "static/media/Strugani 7.eca46f7d.jpg";